import type { GridColDef, GridColumnVisibilityModel, GridSortModel } from '@mui/x-data-grid-pro';

export function isGridDroppingUnloadedMetadataSort(
  isColumnDataLoading: boolean,
  currentSortModel: GridSortModel,
  newSortModel: GridSortModel
): boolean {
  return isColumnDataLoading && newSortModel.length === 0 && !!currentSortModel[0]?.field.startsWith('metadata.');
}

export function isSortColumnShown(
  field: string,
  columns: GridColDef[],
  columnVisibilityModel: GridColumnVisibilityModel | undefined
): boolean {
  return columns.some(column => column.field === field) && columnVisibilityModel?.[field] !== false;
}
